{
  "elementLibrary": {
    "productName": "Título do produto",
    "cargaHoraria": "Carga horária",
    "instrutor": "Nome do instrutor",
    "studentName": "Nome do membro",
    "issuedAt": "Data de emissão",
    "completionDate": "Data de conclusão do curso",
    "hash": "Hash",
    "media": "Média do aluno",
    "documento": "Documento do membro",
    "certText": "Texto de certificação",
    "concludeText": "Texto de conclusão",
    "text": "Texto livre"
  },
  "dateFormats": {
    "dateTime": "dd/MM/yyyy HH:mm",
    "date": "dd/MM/yyyy"
  },
  "list": {
    "title": "Certificados",
    "subtitle": "Gerencie seus certificados e emissões",
    "tabs": {
      "created": "Certificados criados",
      "history": "Histórico de Emissões"
    },
    "deleteConfirm": {
      "title": "Excluir certificado",
      "description": "Tem certeza? Templates com emissões não podem ser excluídos.",
      "confirm": "Excluir"
    },
    "revokeConfirm": {
      "title": "Revogar certificado",
      "description": "O certificado deixará de ser válido na verificação pública.",
      "confirm": "Revogar"
    },
    "toasts": {
      "deleted": "Certificado excluído",
      "deleteError": "Erro ao excluir",
      "revoked": "Certificado revogado",
      "revokeError": "Erro ao revogar",
      "linkCopied": "Link copiado",
      "copyError": "Não foi possível copiar"
    },
    "created": {
      "searchPlaceholder": "Pesquise por título ou código",
      "create": "Criar certificado",
      "columns": {
        "code": "CÓD",
        "certificate": "CERTIFICADO",
        "products": "PRODUTOS",
        "mec": "MEC",
        "createdAt": "CRIADO EM",
        "issued": "EMITIDOS"
      },
      "actions": {
        "edit": "Editar certificado",
        "delete": "Excluir"
      },
      "empty": "Nenhum certificado criado"
    },
    "history": {
      "searchPlaceholder": "Buscar por membro, email ou código",
      "issue": "Emitir certificado",
      "columns": {
        "id": "ID",
        "member": "MEMBRO",
        "product": "PRODUTO",
        "date": "DATA",
        "certificate": "CERTIFICADO"
      },
      "revoked": "Revogado",
      "actions": {
        "view": "Ver certificado",
        "goToProfile": "Ir pro perfil do membro",
        "copyLink": "Copiar link",
        "revoke": "Revogar certificado"
      },
      "empty": "Nenhuma emissão ainda"
    },
    "pagination": {
      "summary": "Página {{page}} de {{totalPages}} ({{total}})",
      "previous": "Anterior",
      "next": "Próxima"
    }
  },
  "editorPage": {
    "toasts": {
      "saved": "Configurações salvas",
      "saveError": "Erro ao salvar"
    },
    "back": "Voltar",
    "title": "Editor de certificado",
    "untitled": "Certificado",
    "save": "Salvar configurações",
    "fields": {
      "title": "Título",
      "workload": "Carga horária",
      "workloadPlaceholder": "ex: 40 horas",
      "mec": "Selo MEC",
      "allowReissue": "Permitir reemissão"
    },
    "products": {
      "title": "Conteúdos associados ({{count}})",
      "searchPlaceholder": "Buscar conteúdo..."
    }
  },
  "createDialog": {
    "validation": {
      "nameMin": "Título deve ter no mínimo 2 caracteres"
    },
    "yes": "Sim",
    "no": "Não",
    "toasts": {
      "created": "Certificado criado",
      "createError": "Erro ao criar certificado"
    },
    "title": "Criar certificado",
    "description": "Configure o certificado. O editor abre em seguida.",
    "nameLabel": "Título do certificado *",
    "namePlaceholder": "Ex: Certificado de Conclusão",
    "mecQuestion": "O certificado terá selo MEC?",
    "reissueQuestion": "Permitir reemissão do certificado?",
    "productsLabel": "Selecionar conteúdos para este certificado",
    "selectedCount_one": "{{count}} selecionado(s)",
    "selectedCount_zero": "{{count}} selecionado(s)",
    "selectedCount_other": "{{count}} selecionado(s)",
    "searchPlaceholder": "Buscar conteúdo...",
    "noProducts": "Nenhum conteúdo encontrado",
    "cancel": "Cancelar",
    "submitting": "Criando...",
    "submit": "Criar certificado"
  },
  "issueDialog": {
    "validation": {
      "selectProduct": "Selecione um conteúdo",
      "memberRequired": "Informe o membro (ID, nome ou email)"
    },
    "toasts": {
      "issued": "Certificado emitido",
      "issueError": "Erro ao emitir certificado"
    },
    "title": "Emitir certificado",
    "description": "Escolha o conteúdo e informe o membro.",
    "memberLabel": "Membro (ID, nome ou email) *",
    "memberPlaceholder": "Ex: maria@email.com",
    "productLabel": "Conteúdo *",
    "searchPlaceholder": "Buscar conteúdo...",
    "noProducts": "Nenhum conteúdo encontrado",
    "cancel": "Cancelar",
    "submitting": "Emitindo...",
    "submit": "Emitir certificado"
  },
  "userTab": {
    "title": "Certificados ({{count}})",
    "revoke": "Revogar",
    "empty": "Este membro ainda não possui certificados"
  },
  "visualEditor": {
    "toasts": {
      "uploadSuccess": "Arquivo enviado",
      "uploadError": "Erro ao enviar arquivo"
    },
    "panel": {
      "elements": "Elementos",
      "others": "Outros",
      "image": "Imagem"
    },
    "toolbar": {
      "background": "Fundo",
      "backgroundColor": "Cor de fundo",
      "backgroundImage": "Imagem de fundo",
      "remove": "Remover",
      "uploadFont": "Upload de fonte",
      "font": "Fonte"
    },
    "canvasHint": "Arraste para posicionar. Clique para selecionar e use as alças verdes para redimensionar.",
    "inspector": {
      "image": "Imagem",
      "text": "Texto",
      "textLabel": "Texto",
      "font": "Fonte",
      "size": "Tamanho",
      "color": "Cor",
      "weight": "Peso",
      "weights": {
        "normal": "Normal",
        "semibold": "Semi-bold",
        "bold": "Bold",
        "black": "Black"
      },
      "alignment": "Alinhamento",
      "align": {
        "left": "Alinhar à esquerda",
        "center": "Centralizar",
        "right": "Alinhar à direita"
      },
      "width": "Largura",
      "height": "Altura",
      "auto": "auto",
      "replaceImage": "Trocar imagem",
      "uploadImage": "Enviar imagem",
      "empty": "Selecione um elemento no canvas para editar."
    }
  },
  "elementDefaults": {
    "certText": "Certificamos que o(a) aluno(a) concluiu com aproveitamento o conteúdo.",
    "concludeText": "Concluído com sucesso na plataforma.",
    "text": "Novo texto"
  }
}
